import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const subscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    toast.success("You're on the list. Welcome to Sable.");
    setEmail("");
  };

  return (
    <footer data-testid="site-footer" className="bg-sand border-t border-line text-ink mt-24 relative z-10">
      <div className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-10">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr_1.4fr] gap-10 md:gap-8">
          <div>
            <h3 className="font-display text-2xl font-extrabold tracking-tight mb-3">SABLE</h3>
            <p className="text-stone text-sm leading-relaxed max-w-xs">
              Sable Health. Quiet-luxury, physician-reviewed, research-grade peptide protocols
              personalized to your goals.
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-stone/70 mb-4">Shop</p>
            <ul className="space-y-3 text-sm text-stone">
              <li><Link to="/shop" className="hover:text-ink transition-colors">All Peptides</Link></li>
              <li><Link to="/intake" className="hover:text-ink transition-colors">AI Assessment</Link></li>
              <li><Link to="/shop" className="hover:text-ink transition-colors">Bestsellers</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-stone/70 mb-4">Company</p>
            <ul className="space-y-3 text-sm text-stone">
              <li><a href="/#science" className="hover:text-ink transition-colors">Science</a></li>
              <li><a href="/#how" className="hover:text-ink transition-colors">How it works</a></li>
              <li><a href="/#faq" className="hover:text-ink transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-stone/70 mb-4">Join the protocol</p>
            <form onSubmit={subscribe} className="flex gap-2">
              <input
                data-testid="newsletter-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="flex-1 bg-bone border border-line rounded-full px-4 py-2.5 text-sm text-ink placeholder:text-stone/50 focus:outline-none focus:border-forest"
              />
              <button
                data-testid="newsletter-submit"
                type="submit"
                className="bg-forest text-[#14100F] font-semibold rounded-full px-5 py-2.5 text-sm hover:bg-forest-dark transition-colors"
              >
                Join
              </button>
            </form>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-line flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-stone/70 max-w-2xl leading-relaxed">
            These statements have not been evaluated by the FDA. Products are not intended to diagnose,
            treat, cure, or prevent any disease. All orders are reviewed by a licensed provider.
          </p>
          <p className="text-xs text-stone/70">© {new Date().getFullYear()} Sable Health.</p>
        </div>
      </div>

      <div className="overflow-hidden select-none pointer-events-none">
        <p className="font-display font-extrabold text-ink/[0.04] leading-none text-center text-[22vw] -mb-[3vw]">
          SABLE
        </p>
      </div>
    </footer>
  );
}
